import QrCodeScan from "../components/QrCodeScan";

export default function QrCodeScannerView() {
  return (
    <>
      <QrCodeScan />
    </>
  );
}
